import { render } from "./InputFieldConfiguration.vue?vue&type=template&id=abcf8baa&scoped=true"
import script from "./InputFieldConfiguration.vue?vue&type=script&lang=js"
export * from "./InputFieldConfiguration.vue?vue&type=script&lang=js"

import "./InputFieldConfiguration.vue?vue&type=style&index=0&id=abcf8baa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abcf8baa"]])

export default __exports__